// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__dhGVV","footer_text":"Footer_footer_text__Lhbwk","footer_text_service":"Footer_footer_text_service__R47fQ"};